// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"LotteryCollectionSearch_searchIcon__XaIv4","optionCheckbox":"LotteryCollectionSearch_optionCheckbox__NfPjb"};